import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
// import Order from './Order';
import History from './History';
import List from './List';
import OtherBankPaid from './OtherBankPaid';
// import List from './List';
import NotFound from '../../../copms/NotFound/NotFound';
// import NewOperation from './NewOperation';
// import OperationList from './OperationList';
// import FirstAuthorisation from './FirstAuthorisation/FirstAuthorisation';
// import SecondAuthorisation from './SecondAuthorisation/SecondAuthorisation';
// import OTPFirstAuthorisation from './OTP/FirstAuthorisation/FirstAuthorisation';
// import OTPSecondAuthorisation from './OTP/SecondAuthorisation/SecondAuthorisation';

export default class Decree extends Component {

    render() {
        let { updateAppState, updateDashboardState, alertState, signLevel, signCount, logout } = this.props;
        return (
            <Switch>
                <Redirect exact from="/dashboard/decree/" to="/dashboard/decree/list" />
                <Route path="/dashboard/decree/list" render={(routeProps) => <List logout={() => logout()} {...routeProps} updateAppState={updateAppState} updateDashboardState={updateDashboardState} alertState={alertState} />} />
                <Route path="/dashboard/decree/history" render={(routeProps) => <History logout={() => logout()} {...routeProps} updateAppState={updateAppState} updateDashboardState={updateDashboardState} alertState={alertState} />} />
                <Route path="/dashboard/decree/other-bank-paid" render={(routeProps) => <OtherBankPaid logout={() => logout()} {...routeProps} updateAppState={updateAppState} updateDashboardState={updateDashboardState} alertState={alertState} />} />
                <Route render={(routeProps) => (<NotFound />)} />
            </Switch>
        )
    }
}
